export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=70171820f6a9351e3cd119a68f3084eb5e4fed755a&name=pushAdClickData!'